export default "/images/Banner_reuna_me.png?72b46883198a626cbc208528ec7f1d84";